import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { reverse } from 'named-urls';

import { Api } from 'constants/Routes.enum';
import fetchData from 'store/fetchData';
import Dropdown from 'components/form/dropdown/Dropdown';

const TriggerDropdown = ({ latestDataType = '', poolId, ...props }) => {
  const dispatch = useDispatch();

  const [triggers, setTriggers] = useState([]);
  const [loadingTriggers, setLoadingTriggers] = useState(true);

  useEffect(() => {
    setLoadingTriggers(true);

    const promise = dispatch(
      fetchData(reverse(Api.TOPICS, { pool_id: poolId })),
    );
    promise
      .then(json => json.json())
      .then(({ topics }) => {
        if (!topics) return;

        const filteredTopics = latestDataType
          ? topics.filter(topic => {
              if (latestDataType === 'trigger') {
                return !topic.latest_data_type;
              }

              return topic.latest_data_type === latestDataType;
            })
          : topics;

        setTriggers(
          filteredTopics.map(topic => {
            return {
              label: topic.public_name,
              value: topic.id.toString(),
            };
          }),
        );
      })
      .finally(() => {
        setLoadingTriggers(false);
      });
  }, [dispatch, latestDataType, poolId]);

  return (
    <Dropdown
      {...props}
      values={triggers}
      hasEmptyOption={false}
      placeholder="Select input signal"
      isLoading={loadingTriggers}
    />
  );
};

export default TriggerDropdown;
